import React from "react";
import {Button, ButtonGroup, Col, Row} from "react-bootstrap";
import FieldGroup from "../../../../components/FieldGroup";
import SelectWrap from "../../../../components/SelectWrap";
import countriesObj from "../../../../data/countries";
import {handleFieldChange} from "../../../../Utils";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class InstallationsHourlyForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
            hourFrom: null,
            hourTo: null,
            affid: null,
            subid: null,
            country: null
        }

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(type) {
        this.props.handleSubmitButton(this.state, type)
    }

    render() {
        return (
          <div>
              <Row>
                  <Col lg={2}>
                      <FieldGroup
                          type="date"
                          name="date"
                          label="Date:"
                          onChange={this.handleFieldChange}
                          value={this.state.date}
                      />
                  </Col>

                  <Col lg={2}>
                      <FieldGroup
                          type="number"
                          name="hourFrom"
                          label="Hour From:"
                          min={0}
                          max={23}
                          onChange={this.handleFieldChange}
                          value={this.state.hourFrom}
                      />
                  </Col>

                  <Col lg={2}>
                      <FieldGroup
                          type="number"
                          name="hourTo"
                          label="Hour To:"
                          min={0}
                          max={23}
                          onChange={this.handleFieldChange}
                          value={this.state.hourTo}
                      />
                  </Col>
              </Row>

              <Row>
                  <Col lg={3}>
                      <SelectWrap
                          values={this.props.affidValues}
                          label="Affid:"
                          name="affid"
                          onChange={this.handleFieldChange}
                          value={this.state.affid}
                          multi
                          required
                      />
                  </Col>

                  <Col lg={3}>
                      <SelectWrap
                          values={this.props.subidValues}
                          label="Subid:"
                          name="subid"
                          onChange={this.handleFieldChange}
                          value={this.state.subid}
                          disabled={!this.props.subidValues.length || !this.state.affid || !this.state.affid.length}
                          multi
                          required
                      />
                  </Col>

                  <Col lg={3}>
                      <SelectWrap
                          values={countriesOptions}
                          label="Countries:"
                          name="country"
                          onChange={this.handleFieldChange}
                          value={this.state.country}
                          disabled={!this.state.subid || !this.state.subid.length}
                          multi
                          required
                      />
                  </Col>
              </Row>

              {
                  this.props.children
              }

              <ButtonGroup style={{ marginTop: '5px', marginBottom: '5px' }}>
                  <Button onClick={() =>this.handleFormSubmit()} bsStyle={'primary'}>Load</Button>
                  <Button onClick={() => this.handleFormSubmit('subid')} bsStyle={'primary'}>Load Subid</Button>
              </ButtonGroup>
          </div>
        )
    }
}

export default InstallationsHourlyForm;


// WEBPACK FOOTER //
// ./src/scenes/ApkInstallationsHourly/components/InstallationsHourlyForm/index.js